// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M4 5H18V22L11 17L4 22V5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"bookmark-double"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 5H18V22L11 17L4 22V5Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 5H18V22L11 17L4 22V5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M11.001 1.00195L18.501 1.00195L22 1.00098V12.501V15.001M22 15.001V16.001L22.001 16.002L22 15.001Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BookmarkDoubleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bookmark-double',
    ref,
    icon: element,
  },
));

BookmarkDoubleIcon.displayName = 'BookmarkDoubleIcon';

export default BookmarkDoubleIcon;
